import { css, StyleSheet } from 'aphrodite';
import { useState } from 'react';
import RespondsIn from '../RespondsIn';
import OpenAt from '../OpenAt';
import ContactForm from './ContactForm';
import ContactFormSuccess from './ContactFormSuccess';

import { calculateBusinessHours } from '../../../../utils/AgentUtils';
import { capitalize } from '../../../../utils/TextProcessing';
import { useDisplayNameOrFirstName } from '../../../../utils/AgentUtils';
import { COLORS } from '../../../../config/themes';

const ContactAgentSidebar = ({ agent, isPrime, isNonPrime, city, state }) => {
  const [formSuccess, setFormSuccess] = useState(false);
  const [otherAgents, setOtherAgents] = useState(false);

  const { noTimes } = calculateBusinessHours({
    hours: agent.business_hours,
    timezone: agent.timezone,
  });

  const next = ({}) => {
    setFormSuccess(true);
  };

  const displayNameOrFirstName = useDisplayNameOrFirstName(agent);

  return (
    <div className={css(styles.contactAgentSidebarContainer)}>
      {formSuccess ? (
        <ContactFormSuccess
          firstName={displayNameOrFirstName}
          funnel="inline-message"
          messageOtherAgents={otherAgents}
          isPrime={isPrime}
          isNonPrime={isNonPrime}
        />
      ) : (
        <>
          <h2 className={css(styles.title)}>
            {isPrime || isNonPrime
              ? `Message ${displayNameOrFirstName}`
              : `Connect with ${capitalize(
                  city
                )}, ${state.toUpperCase()} Agents`}
          </h2>
          <div className={css(styles.responseContainer)}>
            {agent.response_time && (
              <RespondsIn responseTime={agent.response_time} />
            )}
            {agent.business_hours && agent.business_hours.length > 0 && (
              <OpenAt hours={agent.business_hours} timezone={agent.timezone} />
            )}
          </div>
          <ContactForm
            agent={agent}
            nextScreen={next}
            funnel="inline-message"
            setOtherAgents={setOtherAgents}
            isPrime={isPrime}
            isNonPrime={isNonPrime}
            city={city}
            state={state}
          />
        </>
      )}
    </div>
  );
};

const styles = StyleSheet.create({
  contactAgentSidebarContainer: {
    '@media only screen and (min-width: 1440px)': {
      padding: '24px 32px',
      paddingBottom: 20,
    },

    background: '#fff',
    border: '1px solid rgba(233, 233, 233, 1)',
    boxShadow: '0px 0px 28px 0px rgba(30, 41, 59, 0.08)',
    color: COLORS.BLACK(),
    padding: '16px 24px',
    borderRadius: 5,
  },
  title: {
    fontWeight: 700,
    fontSize: 20,
    marginBottom: 10,
  },
  button: {
    width: '100%',
    padding: '10px 0',
    height: 'unset',
    fontSize: 16,
    fontWeight: 600,
  },
  messageAgentButton: {
    background: COLORS.PRIMARY_ACTION(),
    borderRadius: 5,
    marginBottom: 14,
  },
  envelope: {
    width: 20,
    height: 20,
    marginRight: 13,
  },
  responseContainer: {
    marginTop: 10,
    display: 'flex',
    flexDirection: 'column',
  },
});
export default ContactAgentSidebar;
